<script>export let value = "";
export let type = void 0;
export let position = void 0;
export let __index = void 0;
type && position && __index;
</script>

{value}
